// seo.config.js
export const siteConfig = {
  siteName: "QuickTor מערכת לניהול תורים ותזכורות",
  defaultLocale: "he_IL",
  baseUrl: "https://quicktor.co.il",
  description: "פתרון לבעיה במקום אחד עם קוויק תור: ניהול תורים אונליין, תזכורות בוואטסאפ, גביית תשלום מלקוחות, קבלות, דף עסקי ממותג וניהול עובדים. סוף להתעסקות מיותרת!",
  verifications: {
    google: "DvOcV86mkYD-XXMIIUz4hgVXQqRl3lzazqQ1IgqDdgE",
    facebook: "7mdup0iqy13ng89l4imdtl241i9o4s",
  },
  geo: {
    region: "IL",
    placename: "Israel",
    position: "32.0853;34.7818", // Tel Aviv coordinates
    latitude: "32.0853",
    longitude: "34.7818"
  },
  contact: {
    phone: "055-7259188",
    email: "mail@quicktor.co.il",
    address: {
      addressLocality: "תל אביב",
      addressCountry: "IL"
    }
  },
  software: {
    price: "99.00",
    currency: "ILS",
    operatingSystem: "Web Browser",
    applicationCategory: "BusinessApplication"
  }
};